import React from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  header: {
    padding: theme.spacing(0, 10, 3, 0),
    [theme.breakpoints.down("sm")]: {
      paddingRight: 0
    }
  }
}));

export default function SlideOutTitle(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Typography variant="h2" color="textSecondary" className={classes.header}>
      {t("welcomeSlideOut.welcomeMessage", {
        name: props.currentUserFirstName
      })}
    </Typography>
  );
}

SlideOutTitle.propTypes = {
  title: PropTypes.string
};
